<div [class]="alertClass()" role="alert">
  <i [class]="icon()"></i>
  <div class="alert-text-container">
    @if (title()) {
      <h3 class="alert-title">
        {{ title() }}
      </h3>
    }
    @if (text()) {
    <p class="alert-text">
        {{ text() }}
    </p>
    }
  </div>
</div>